module.exports = __webpack_public_path__ + "static/img/40011 (2).6873c0f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40011 (2).webp
// module id = Wy+s
// module chunks = 14